<template>
  <ContextColorProvider class="custom-operation-details" context="trade">
    <NavBar data-testid="operation-details-nav">
      <template #left>
        <BackButton />
      </template>
    </NavBar>
    <main class="custom-operation-details__main">
      <SpinnerLoader
        v-if="isLoading"
        class="custom-operation-details__loading"
        :size="48"
      />
      <HelperViewStatus
        v-else-if="hasError"
        class="custom-operation-details__loading"
        :title="errorMessage"
        description="Aguarde um momento e tente novamente"
        button-label="Tentar novamente"
        status="alert"
        @click="fetchCustomOperationData"
      />
      <CustomOperationDetailsContent
        v-else
        :custom-operation-data="customOperationData"
      />
    </main>
  </ContextColorProvider>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router/composables';

import {
  ContextColorProvider,
  NavBar,
  SpinnerLoader,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { CustomOperationDetailsContent } from './components/CustomOperationDetailsContent';

import {
  getCustomOperationDetails,
  CustomOperation
} from '@/modules/trade/services/custom-operations';
import { isBFFError } from '@/modules/common/helpers/bff';

const isLoading = ref<boolean>(true);
const hasError = ref<boolean>(false);
const errorMessage = ref<string>(
  'Não foi possível carregar a operação personalizada'
);
const customOperationData = ref<CustomOperation>({} as CustomOperation);

const route = useRoute();

const customOperationId = computed(() => {
  const { id } = route.params;

  return id;
});

onMounted(() => {
  fetchCustomOperationData();
});

const fetchCustomOperationData = async () => {
  try {
    isLoading.value = true;
    hasError.value = false;

    const response = await getCustomOperationDetails(customOperationId.value);

    customOperationData.value = response;
  } catch (e) {
    let message = 'Não foi possível carregar a operação personalizada';
    hasError.value = true;

    if (isBFFError(e)) {
      message = e.error.message.formatted;
    }

    errorMessage.value = message;
  } finally {
    isLoading.value = false;
  }
};
</script>
<style lang="less" scoped>
.custom-operation-details {
  display: flex;
  min-height: 100vh;
  flex-direction: column;

  &__main {
    padding: @size-spacing-x600 @size-spacing-x500;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-grow: 1;

    .to-lg({ padding: @size-spacing-x400 @size-spacing-x400;});
  }

  &__loading {
    align-self: center;
  }

  &__error {
    align-self: center;
  }
}
</style>
